import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PosterSimmerComponent } from "./poster-simmer/poster-simmer.component";
import { BannerSimmerComponent } from "./banner-simmer/banner-simmer.component";
import { RectangleSimmerComponent } from "./rectangle-simmer/rectangle-simmer.component";
import { GridSimmerComponent } from "./grid-simmer/grid-simmer.component";
import { SliderSimmerComponent } from "./slider-simmer/slider-simmer.component";
import { GenerSliderSimmerComponent } from "./gener-slider-simmer/gener-slider-simmer.component";
import { MusicListSimmerComponent } from "./music-list-simmer/music-list-simmer.component";
import { SongsSimmerComponent } from "./songs-simmer/songs-simmer.component";
@NgModule({
  declarations: [
    PosterSimmerComponent,
    BannerSimmerComponent,
    RectangleSimmerComponent,
    GridSimmerComponent,
    SliderSimmerComponent,
    GenerSliderSimmerComponent,
    MusicListSimmerComponent,
    SongsSimmerComponent,
  ],
  imports: [CommonModule],
  exports: [
    BannerSimmerComponent,
    PosterSimmerComponent,
    RectangleSimmerComponent,
    GridSimmerComponent,
    SliderSimmerComponent,
    GenerSliderSimmerComponent,
    MusicListSimmerComponent,
    SongsSimmerComponent,
  ],
})
export class ResulableSimmerModule {}
